export default __webpack_public_path__ + "_/images/svg_icons/app-info-ae88bc1fe213ad60c05cddc3b214aa7e6a908f4890364584b00b75841e665fde.svg";